export default __webpack_public_path__ + "static/media/wave-partition-mobile.fd93f8b0.png";